/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportInstallationsContent from "./ImportInstallationsContent";
import { ROUTE_COMPRESSORS_IMPORT } from "../../../../routes";

export default class extends Component {
  static propTypes = ImportInstallationsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          To import your installations, the data must be saved in ODS or TSV format and 
          follow the structure below:
        </p>

        <ul>
          <li>Customer number <i>(optional) - If an installation line does not have a customer number, the installation will be created for the customer account to which you are attached.</i></li>
          <li>Site no.</li>
          <li>Installation no.</li>
          <li>
            Fluid
          </li>
          <li>
            Oil <i>(optional)</i>
          </li>
          <li>
            Coolant <i>(optional)</i>
          </li>
          <li>Designation</li>
          <li>Nominal load</li>
          <li>Current load</li>
          <li>
            Identifier number <i>(optional)</i>
          </li>
          <li>Marker</li>
          <li>Date of commissioning</li>
          <li>Last periodic control date</li>
          <li>
            Indirect leak detector <i>(0 = no detector | 1 = presence of a detector)</i>
          </li>
        </ul>
        <small>Fields required only when adding a compressor to the installation:</small>
        <ul>
          <li>Compressor: Marker</li>
          <li>Compressor: Identifier number <i>(optional)</i></li>
          <li>Compressor: Serial number <i>(optional)</i></li>
          <li>Compressor: Type</li>
          <li>Compressor: Classification</li>
          <li>Compressor: Brand <i>(optional)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          To import several compressors into a single installation, <a href={ROUTE_COMPRESSORS_IMPORT}>click here</a>.
        </p>

        <p>
          After integration, a summary will inform you about the number of
          entities created or updated, and will provide an anomaly file
          containing the unintegrated lines, and the reason(s) for the
          rejection.
        </p>

        <p>The possible reasons for anomalies are:</p>

        <ul>
          <li>Absence of mandatory data</li>
          <li>Fluid, oil or coolant not available</li>
          <li>Top value different from 1/0</li>
          <li>Invalid date</li>
          <li>Type, classification or brand of compressor not available</li>
        </ul>
      </div>
    );
  }
}
